"use client"

import * as React from "react"
import { useToast as useToastHook } from "@/hooks/use-toast"
import type { ToastActionElement, ToastProps } from "@/types/toast"

export type { ToastProps, ToastActionElement }

const useToast = () => {
  return useToastHook()
}

export { useToast } 